import React, { useEffect, useState } from "react";
import "./style.css";
import { Dropdown, Modal } from "react-bootstrap";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";
import { Link } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";


function SavedSec(props) {
	const sessionId = localStorage.getItem("sessionId");

	// ...............................All Job List Start.......................................
	const userUID = localStorage.getItem("userUID");

	const [totalPages, setTotalPages] = useState(0);
	const [jobsavedList, setSavedjobList] = useState([]); 
	const [search, setSearch] = useState([]);
	const [isError, setIsError] = useState(false);
   const [currentPage,setCurrentPage] = useState(1)
	const [isLoading, setIsLoading] = useState(true);
	const [totalRows, setTotalRows] = useState(1);

	const [unAuthorizeError, setUnAuthorizeError] = useState("");
	const [unauthModal, setUnauthModal] = useState(false);
	const handleunauthModal = () => setUnauthModal(true);
	const handlecloseunauthModal = () => setUnauthModal(false);
	
	const getAllSavedjob = (page) => {
		console.log("page====>", page);
      setCurrentPage(page)
		try {
			const data = {
				sessionId: sessionId,
				pageNumber: page,
				pageSize: 10,
			};
			console.log("data====>", data);
 
			axios
							.post(`/Job/GetSavedJobs`, data)
							.then((response) => {
								const res = response?.data?.responseData || {};
								setSavedjobList(res?.jobsList || []);
								setTotalRows(response?.data?.responseData?.paging?.allDataCount || 0);

								setIsLoading(false);
								setIsError(res.length === 0); // If no jobs, set error state
								setIsLoading(false);
							})
							.catch((err) => {
								console.error("Error fetching jobs:", err);
								setIsError(true); // Handle error state
								setIsLoading(false);
								if (err.response && err.response.status === 409) {
									// toast.error(err.response.data.message);
									console.error("Unexpected error:", err);
									setUnAuthorizeError(err.response.data.message)
									handleunauthModal()
								  } else {
									 console.error("Unexpected error:", err);
									
								  }
							});
		} catch (e) {
			console.log("Error fetching saved jobs", e);
			setIsLoading(false);
			if (e.response && e.response.status === 404) {
				setSavedjobList([]); // Clear list if not found
			}
		}
	};

	// const getAllSavedjob = (page) => {
	// 	console.log("page====>", page);
	
	// 	try {
	// 		const data = {
	// 			sessionId: sessionId,
	// 			pageNumber: page,
	// 			pageSize: 10,
	// 		};
	// 		console.log("data====>", data);
	
	// 		axios.post(`/Job/GetSavedJobs`, data).then((response) => {
	// 			console.log("Warning111", response);

	// 			const res = response?.data;
				
	// 			if (res?.status === "Warning") {
	// 				toast.success(res); // Show alert with the message
	// 				console.log("Warning111", res);
					
	// 			} else {
	// 				setSavedjobList(res?.responseData?.jobsList || []);
	// 				setTotalRows(res?.responseData?.paging?.allDataCount || 0);
	// 			}
	
	// 			setIsLoading(false);
	// 		});
	// 	} catch (e) {
	// 		console.log("Error fetching saved jobs", e);
	// 		setIsLoading(false);
	// 		if (e.response && e.response.status === 404) {
	// 			setSavedjobList([]); // Clear list if not found
	// 		}
	// 	}
	// };
	
	useEffect(() => {
		getAllSavedjob(1);
	}, [search]);
 

		//  ........................ job details modal ...............................
		const [selectedJob, setSelectedJob] = useState(null);
		const [showJobDetailModal, setShowJobDetailModal] = useState(false);
	
		const handleJobClick = (job) => {
			setSelectedJob(job);
			setShowJobDetailModal(true);
		};

		const handleCloseJobDetailModal = () => {
			setShowJobDetailModal(false);
			setSelectedJob(null);
		};
	// ...............................All Jobs List End.......................................

	// ................................UnSavedJob Start....................

	const UnSavedJob = async (jobId) => {
		const data = {
			sessionId: sessionId,
			jobId: jobId,
		};
		console.log("session ids", sessionId);

		try {
			await axios.post("/JobAction/UnSaveJob", data).then((resData) => {
				console.log("UnSaved job", resData.data.message);
				setSavedjobList((prev) => prev.filter((item) => item.jobId !== jobId));
				toast.success(resData.data.message);
				getAllSavedjob();
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
				console.log("Unsaved ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	// ........................................UnSavedJob End..........................

	const columns = [
		{
			name: "Jobs Details",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div className="job-img text-center mt-2">
						<img
							src={row.compImage}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>
					</div>
					<div className="content text-center">
						<div
							className="justify-content-center"
							style={{ display: "flex", alignItems: "center", gap: "10px" }}
						>
							{/* <div className="pointer jobinfo f-600 ">
								<a href={`/job/${row.jobId}`}>{row.title}</a>
							</div> */}
							<div className="pointer jobinfo f-600 " style={{ color: "rgb(13 110 253)" }}
							onClick={() => {
								handleJobClick(row)
							}}>
							{row.title}
						</div>

						</div>
						<div className=" f-500 ">
							<p className="mb-1 mt-1">{row.cityName}</p>
						</div>
						<div className="mb-2">
							 {moment.utc(row.creationTime).local().format("DD MMM YYYY (h:m A)")}
						 </div>

					</div> 
				</div>

			),
		},
		{
					name: "Company Name",
					center: true,
					sortable: true,
					minWidth: "200px",
					selector: (row) =>(
						<div className="Applied Comp f-600">
							{row.compType === "Company" ? (
								<Link to={`/Company/${row.compUid}`}>
								{row.compName} 
								</Link>
							) : (
		
							<Link to={`/Recruiter/${row.compUid}`}>
							{row.compName} 
							</Link>
							)}
							
						</div>
					) 
				},

		{
			name: "Designation",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.designationName,
		},
		 
		{
			name: "Action",
			center: true,
			minWidth: "200px",
			cell: (row) => (
				<>
					<Dropdown>
						<Dropdown.Toggle as="span" className="icon-togg">
							<MoreHorizSharpIcon className="ms-2" />
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item href={`/job/${row.jobId}`}>
								View Job
							</Dropdown.Item>
							<Dropdown.Item
								href="#"
								onClick={() => {
									UnSavedJob(row.jobId);
									getAllSavedjob();
								}}
							>
								Unsave
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</>
			),
		},
	];

	const addTargetBlankToAnchors = (html) => {
		const div = document.createElement('div');
		div.innerHTML = html;

		const anchors = div.querySelectorAll('a');
		anchors.forEach(anchor => {
			anchor.setAttribute('target', '_blank');
			anchor.setAttribute('rel', 'noopener noreferrer');
		});

		return div.innerHTML;
	};


	const linkifyContent = (htmlContent) => {
		const urlPattern = /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
		return htmlContent.replace(urlPattern, function (url) {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	};
	// .................................shortDescription
	

	return (
		<>
		<section className="pricing-section-three container jobapplication view-job-style  saved-drop-section">
			<div className="mt-2">
				<h6 className="orange-title">
					<span className="orange-box me-2"></span>
					{props.title}
				</h6>
			</div>
			<div className="container st3">
				<div className="row">
					<div className="col-lg-12">
						{isLoading ? (
							<div className="row mt-2">
								<div className="col-md-12">
									<ShimmerDiv mode="light" height={100} width={'100%'} />
								</div>
								<div className="col-md-12 mt-2">
									<ShimmerDiv mode="light" height={100} width={'100%'} />
								</div>
								<div className="col-md-12 mt-2">
									<ShimmerDiv mode="light" height={100} width={'100%'} />
								</div>
								<div className="col-md-12 mt-2">
									<ShimmerDiv mode="light" height={100} width={'100%'} />
								</div>
							</div>
						) : isError ? (
							<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
								<img src={error} alt="404 Not Found" width={300} />
								{/* <p class=" d-flex justify-content-center">There is no record to display</p> */}
							</div>
						) :
							jobsavedList.length === 0 ? (
								<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
									{/* <p class=" d-flex justify-content-center">There are no records to display.</p> */}
									<img src={error} alt="404 Not Found" width={300} />
								</div>
							)
								:
								(
									<div className="scroll-react-dataTable">
										<div className="react-dataTable react-table-colorclass">
											<DataTable
												noHeader
												pagination
												columns={columns}
												data={jobsavedList} // Pass the candidate list to the table
												progressPending={isLoading} // Show a loader when fetching data
												paginationServer // Enable server-side pagination
												paginationPerPage={10} // Number of rows per page
												paginationTotalRows={totalRows} // Total rows for calculating pages
												paginationRowsPerPageOptions={[]}
												paginationDefaultPage={currentPage}
												onChangePage={(page) => {
													getAllSavedjob(page); // Update the current page
												}}
												sortIcon={<ChevronDown size={5} />} // Sorting icon
												className="react-dataTable" // Custom class for styling
											/>

										</div>

									</div>
								)}
					</div>
				</div>
			</div>
		</section>


	{/*....................................  Job detail Modal Start ................................*/}

			<Modal show={showJobDetailModal} onHide={handleCloseJobDetailModal} centered>
				<Modal.Header>
					<Modal.Title>Job Details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseJobDetailModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className="mb-3">
						{selectedJob?.title && (
							<p>
								<span className="f-600">Title: </span> {selectedJob.title}
							</p>
						)}
						{selectedJob?.cityName && (
							<p>
								<span className="f-600">City: </span> {selectedJob.cityName}
							</p>
						)}
						
						{selectedJob?.hiringStatusName && (
							<p>
								<span className="f-600">Status: </span> {selectedJob.hiringStatusName}
							</p>
						)}
						{selectedJob?.designationName && (
							<p>
								<span className="f-600">Designation: </span> {selectedJob.designationName}
							</p>
						)}
						{selectedJob?.compName && (
							<p>
								<span className="f-600">Company: </span> {selectedJob.compName}
							</p>
						)}
						{selectedJob?.shortDescription && (
							<p>
								<span className="f-600">Short Description: </span>
								{/* {selectedJob.shortDescription} */}
								<div className="pointer"
									dangerouslySetInnerHTML={{
										__html: linkifyContent(
											addTargetBlankToAnchors(selectedJob.shortDescription)
										)
									}}
								>
								</div>
							</p>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Link
						to={`/job/${selectedJob?.jobId}`}
						className="btn khojPrimaryBtn me-2"
					>
						View
					</Link>
				</Modal.Footer>
			</Modal>
			{/*....................................  Job details SModal End ................................*/}
		  
		 {/* ...............UnAuthorize modal............  */}
									{unAuthorizeError ? (
										  <Modal show={unauthModal} centered>
										  <Modal.Header>
											  <Modal.Title>Unauthorize session expired</Modal.Title> 
										  </Modal.Header>
										  <Modal.Body className="settings">
											  <div className=" mb-3">
												  <p>{unAuthorizeError}</p>
											  </div>
										  </Modal.Body>
										  <Modal.Footer>
										  <Link
										  className="pointer"
												to="/Login"
												onClick={() => {
												  localStorage.removeItem("token"); // Remove authentication token
												  sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
												  localStorage.removeItem("Module");
												}}
											  >
												<button className="btn btn-danger ">Login</button>
											  </Link>
											{/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}
						  
										  </Modal.Footer>
						  
									  </Modal>
									  ) : (
										""
									  )}
		</>
	);
}

export default SavedSec;
